import React, { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiMe, apiLogout, getEmail, getToken } from "../api";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [session, setSession] = useState(() => {
    const t = getToken();
    const e = getEmail();
    return t && e ? { token: t, email: e } : null;
  });
  const [verifying, setVerifying] = useState(!!session);

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      if (!session) {
        setVerifying(false);
        return;
      }
      try {
        await apiMe();
      } catch (e) {
        if (mounted) {
          apiLogout();
          setSession(null);
        }
      } finally {
        if (mounted) setVerifying(false);
      }
    };
    verify();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    try {
      const data = await apiLogin(email, password);
      setSession({ token: data.access_token, email: data.email });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message || "Login failed" };
    }
  };

  const logout = () => {
    apiLogout();
    setSession(null);
  };

  return (
    <AdminContext.Provider value={{ session, isAdmin: !!session, verifying, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin must be used inside AdminProvider");
  return ctx;
};
